import React from 'react';
/* eslint-disable */
import { Route, Switch, withRouter } from 'react-router-dom';
import Layout from '../Layout/index';
import MainWrapper from './MainWrapper';

import Logout from '../Logout';
// import LogIn from '../LogIn/index';
import IndexPanel from '../IndexPanel/index';
import FaqsPanel from '../FaqsPanel/index';

const wrappedRoutes = () => (
	<div>
		<Layout />
	</div>
);

const Router = () => (
	<MainWrapper>
		<main>
			<Switch>
				<Route
					exact
					path={process.env.PUBLIC_URL + '/'}
					component={IndexPanel}
				/>
				<Route exact path="/logout" component={Logout} />
				<Route exact path="/login" component={IndexPanel} />
				<Route exact path="/home" component={IndexPanel} />
				<Route exact path="/faqs" component={FaqsPanel} />
				<Route path="/" component={wrappedRoutes} />
			</Switch>
		</main>
	</MainWrapper>
);

export default withRouter(Router);
